import { createStore, applyMiddleware } from 'redux'
import thunkMiddleware from 'redux-thunk'
import logger from 'redux-logger'
import { loadUser } from 'redux-oidc'
import userManager from '../utils/userManager'
import { routerMiddleware } from 'connected-react-router'
import createRootReducer from '../reducers'

const configureStore = (history) => {
  userManager.events.addSilentRenewError(function (error) {
    console.error('error while renewing the access token', error)
  })

  const allReducers = createRootReducer(history)

  const store = createStore(allReducers, applyMiddleware(
    thunkMiddleware,
    routerMiddleware(history),
    logger
  ))
  loadUser(store, userManager)

  return store
}

export default configureStore
